import { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'src/utils/i18n'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { notification, Button, Modal } from 'antd'
import { getLocalAndroidAll } from '/src/@api/dashboard'
import { checkAppLastVersion } from 'src/@api/android'
import Image from 'next/image'
import dayjs from 'dayjs'
import { disconnectCheck, extendSubscriptionTime, getMenuFavorite, postMenuFavorite } from 'src/@api/dashboard'
import Link from 'next/link'
import { userDeviceCurrent, sendLikeType, getUserAccountOrder } from 'src/@api/login'
import { getNotBindOrder, getAllUserDevice } from 'src/@api/login'
import { selectDeviceRequestKey, setCurrentTab, toggleNavVisibility } from 'src/store/apps/Common'
import { useDispatch, useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import FirstBinding from 'src/components/FirstBinding'
import PermissionCheck from 'src/components/PermissionCheck'
import { messageInfo } from 'src/components/Message'
import ExpirationReminder from 'src/components/ExpirationReminder'
import DisconnectDetection from 'src/components/DisconnectDetection'
import { matchCurrentDevice, reloadAfterRenewSuccess } from 'src/utils/refreshSubscriptionExpire'
import { resolveDeviceOrder, pickLatestExpireOrder, resolveCardSubscription } from 'src/utils/currentOrder'
import { isBasicOrderLevel } from 'src/utils/orderLevel'
import ContentLoading from 'src/components/ContentLoading'
import { fetchRenewProductIdForOrder } from 'src/utils/renewalPlans'
import { applyAdvanceBadgeCount } from 'src/utils/androidLocalFeatureBadgeMap'

let allIcon = [
  {
    id: 0,
    name: 'Locations',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_LOCATIONS,
    num: 0,
    href: '/android/local/locations',
    eventName: 'Click_GPSlocation'
  },
  {
    id: 1,
    name: 'Contact',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_CONTACTS,
    num: 0,
    href: '/android/local/contacts',
    eventName: 'Click_Contact'
  },
  {
    id: 2,
    name: 'Text Messages',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_SMS,
    num: 0,
    href: '/android/local/text-messages',
    eventName: 'Click_Textmessage'
  },
  {
    id: 3,
    name: 'Installed Apps',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_APPS,
    num: '0',
    href: '/android/local/apps',
    eventName: 'Click_Installedapp'
  },
  {
    id: 4,
    name: 'Video',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_VIDEO,
    num: 0,
    href: '/android/local/videos',
    eventName: 'Click_Video'
  },
  {
    id: 5,
    name: 'Photo',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_PHOTOS,
    num: 0,
    href: '/android/local/photos',
    eventName: 'Click_Photo'
  },
  {
    id: 6,
    name: 'Calls',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_CALLS,
    num: 0,
    href: '/android/local/calls',
    eventName: 'Click_Call'
  },
  {
    id: 7,
    name: 'WI-FI network',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_WIFI,
    num: 0,
    href: '/android/local/wifi-networks',
    eventName: 'Click_Wifinetwork'
  },
  {
    id: 8,
    name: 'Calendar',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_CALENDARS,
    num: 0,
    href: '/android/local/calendars',
    eventName: 'Click_Calendar'
  },
  {
    id: 9,
    name: 'Whatsapp',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_WHATSAPP,
    num: 0,
    href: '/android/local/whatsapp',
    eventName: 'Click_WhatsApp'
  },
  {
    id: 10,
    name: 'Line',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_LINE,
    num: 0,
    href: '/android/local/line',
    eventName: 'Click_LINE'
  },
  {
    id: 11,
    name: 'Kik',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_KIK,
    num: 0,
    href: '/android/local/kik',
    eventName: 'Click_Kik'
  },
  {
    id: 12,
    name: 'Messenger',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_MESSENGE,
    num: 0,
    href: '/android/local/messenger',
    eventName: 'Click_Messenger'
  },
  {
    id: 13,
    name: 'Instagram',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_INSTAGRAM,
    num: 0,
    href: '/android/local/instagram',
    eventName: 'Click_Instagram'
  },
  {
    id: 14,
    name: 'Viber',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_VIBER,
    num: 0,
    href: '/android/local/viber',
    eventName: 'Click_Viber'
  },
  {
    id: 15,
    name: 'Tinder',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_TINDER,
    num: 0,
    href: '/android/local/tinder',
    eventName: 'Click_Tinder'
  },
  {
    id: 16,
    name: 'Skype',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_SKYPE,
    num: 0,
    href: '/android/local/skype',
    eventName: 'Click_Skype'
  },
  {
    id: 17,
    name: 'Youtube',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_YOUTUBE,
    num: 0,
    href: '/android/local/youtube',
    eventName: 'Click_Youtube'
  },
  {
    id: 18,
    name: 'Snapchat',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_SNAPCHAT,
    num: 0,
    href: '/android/local/snapchat',
    eventName: 'Click_Snapchat'
  },
  {
    id: 19,
    name: 'Telegram',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_TELEGRAM,
    num: 0,
    href: '/android/local/telegram',
    eventName: 'Click_Telegram'
  },
  {
    id: 20,
    name: 'WeChat',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_WECHAT,
    num: 0,
    href: '/android/local/we-chat',
    eventName: 'Click_WeChat'
  },
  {
    id: 21,
    name: 'QQ',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_QQ,
    num: 0,
    href: '/android/local/qq',
    eventName: 'Click_QQ'
  },
  {
    id: 22,
    name: 'Facebook',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_FACEBOOK,
    num: 0,
    href: '/android/local/facebook',
    eventName: 'Click_Facebook'
  },
  {
    id: 23,
    name: 'Teams',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_TEAMS,
    num: 0,
    href: '/android/local/teams',
    eventName: 'Click_Teams'
  },
  {
    id: 24,
    name: 'TikTok',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_TIKTOK,
    num: 0,
    href: '/android/local/tik-tok',
    eventName: 'Click_TikTok'
  },
  {
    id: 25,
    name: 'Discord',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_DISCORD,
    num: 0,
    href: '/android/local/discord',
    eventName: 'Click_Discord'
  },
  {
    id: 26,
    name: 'Browser History',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_CHROME,
    num: 0,
    href: '/android/local/browser-history',
    eventName: 'Click_Browserhistory'
  },
  {
    id: 27,
    name: 'Botim',
    img: '/images/dashboard/new-android/botim.svg',
    num: 0,
    href: '/android/local/botim',
    eventName: 'Click_Botim'
  },
  {
    id: 28,
    name: 'Kakao Talk',
    img: '/images/dashboard/new-android/kakaotalk.svg',
    num: 0,
    href: '/android/local/kakao-talk',
    eventName: 'Click_KakaoTalk'
  },
  {
    id: 29,
    name: 'Twitter',
    img: '/images/dashboard/new-android/twitter.svg',
    num: 0,
    href: '/android/local/twitter',
    eventName: 'Click_Twitter'
  },
  {
    id: 30,
    name: 'Gmail',
    img: '/images/dashboard/new-android/gmail.svg',
    num: 0,
    href: '/android/local/gmail',
    eventName: 'Click_Gmail'
  },
  {
    id: 31,
    name: 'Easilydo mail',
    img: '/images/dashboard/new-android/easilydo-mail.svg',
    num: 0,
    href: '/android/local/easilydo-mail',
    eventName: 'Click_Easilydomail'
  },
  {
    id: 32,
    name: 'Keylogger',
    img: '/images/dashboard/new-android/keylogger.svg',
    num: 0,
    href: '/android/local/keylogger',
    eventName: 'Click_Keylogger'
  },
  {
    id: 33,
    name: 'Record Surround',
    img: '/images/dashboard/new-android/record-surround.svg',
    num: 0,
    href: '/android/local/record-surround',
    eventName: 'Click_Recordsurround'
  },
  {
    id: 34,
    name: 'Live Screenshot',
    img: '/images/dashboard/new-android/live-screenshot.svg',
    num: 0,
    href: '/android/local/live-screenshot',
    eventName: 'Click_Livescreenshot'
  },
  {
    id: 35,
    name: 'Record Video',
    img: '/images/dashboard/new-android/record-video.svg',
    num: 0,
    href: '/android/local/record-video',
    eventName: 'Click_Recordvideo'
  },
  {
    id: 36,
    name: 'ChatGPT',
    img: '/images/dashboard/new-android/chatgpt.svg',
    num: 0,
    href: '/android/local/chatgpt',
    eventName: 'Click_ChatGPT',
    noBg: true
  },
  {
    id: 37,
    name: 'Gemini',
    img: '/images/dashboard/new-android/gemini.svg',
    num: 0,
    href: '/android/local/gemini',
    eventName: 'Click_Gemini',
    noBg: true
  }
]

let otherAppList = [
  {
    id: 0,
    name: 'Geofence',
    img: '/images/dashboard/new-android/geo.svg',
    num: 0,
    href: '/android/local/geofence',
    eventName: 'Click_Geofence'
  },
  {
    id: 1,
    name: 'Keyword Alerts',
    img: '/images/dashboard/new-android/keyword-alerts.svg',
    num: 0,
    href: '/android/local/keyword-alerts',
    eventName: 'Click_Keywordalerts'
  },
  {
    id: 2,
    name: 'Screen Time',
    img: '/images/dashboard/new-android/screen-time.svg',
    num: 0,
    href: '/android/local/screen-time',
    eventName: 'Click_Screentime'
  },
  {
    id: 3,
    name: 'Notifications',
    img: '/images/dashboard/new-android/notifications.svg',
    num: 0,
    href: '/android/local/notifications',
    eventName: 'Click_Notifications'
  },
  {
    id: 4,
    name: 'Record Screen',
    img: '/images/dashboard/new-android/record-screen.svg',
    num: 0,
    href: '/android/local/record-screen',
    eventName: 'Click_Recordscreen'
  },
  {
    id: 5,
    name: 'Take Photos',
    img: '/images/dashboard/new-android/take-photos.svg',
    num: 0,
    href: '/android/local/take-photos',
    eventName: 'Click_Takephotos'
  },
  {
    id: 6,
    name: 'Block Applications',
    img: '/images/dashboard/new-android/block-apps.svg',
    num: 0,
    href: '/android/local/block-applications',
    eventName: 'Click_Blockapplications'
  },
  {
    id: 7,
    name: 'Block Wi-Fi',
    img: '/images/dashboard/new-android/block-wifi.svg',
    num: 0,
    href: '/android/local/block-wifi',
    eventName: 'Click_Blockwifi'
  },
  {
    id: 8,
    name: 'Block Website',
    img: '/images/dashboard/new-android/block-websites.svg',
    num: 0,
    href: '/android/local/block-website',
    eventName: 'Click_Blockwebsite'
  }
]

const Dashboard = () => {
  const { t } = useTranslation('common')
  const router = useRouter()
  const dispatch = useDispatch()

  // 异步 Dashboard 拉数归属键，切换设备后旧请求结果会被忽略
  const deviceRequestKey = useSelector(selectDeviceRequestKey)
  const deviceRequestKeyRef = useRef(deviceRequestKey)
  deviceRequestKeyRef.current = deviceRequestKey

  let { data: userData } = JSON.parse(localStorage.getItem('userData'))

  const readDeviceUsername = () =>
    JSON.parse(localStorage.getItem('DeviceUser') || 'null')?.username || ''

  const [api, contextHolder] = notification.useNotification()

  const [isInviteComment, setIsInviteComment] = useState(false)

  // 提示安装最新app

  const openNotification = code => {
    api.open({
      description: (
        <>
          <p style={{ marginBottom: '5px' }}>
            {t(
              'The monitoring application you installed is not the latest version. Please go to the link below to download the latest version'
            )}
          </p>
          <a
            href='https://msafely.net/download'
            style={{ textDecoration: 'underline', color: '#1677ff' }}
            target='_blank'
            rel='noopener noreferrer'
          >
            https://msafely.net/download
          </a>
          {code ? (
            <p style={{ marginTop: '5px' }}>
              {t('registration code')}: <span style={{ color: '#1677ff' }}>{code}</span>
            </p>
          ) : null}
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: '20px'
            }}
          >
            <Button
              onClick={() => {
                localStorage.setItem('reminderLater', new Date().getTime() + 1000 * 60 * 60 * 24 * 7)
                api.destroy()
              }}
            >
              {t('Remind me later')}
            </Button>
          </div>
        </>
      ),
      duration: 30
    })
  }

  // 获取是否是最新版本
  const getInstallAppOpen = async requestKey => {
    if (new Date().getTime() < Number(localStorage.getItem('reminderLater'))) return

    let check = await checkAppLastVersion({
      type: 'Update service',
      device: readDeviceUsername()
    })
    if (deviceRequestKeyRef.current !== requestKey) return
    if (check.update) {
      openNotification(check.code)
    }
  }
  useEffect(() => {
    getInstallAppOpen(deviceRequestKey)
  }, [deviceRequestKey])

  // 数据模块
  const [typeModule, setTypeModule] = useState(allIcon)
  const [otherModule, setOtherModule] = useState(otherAppList)
  const [isLoading, setIsLoading] = useState(true)

  // 克隆列表
  const [cloneList, setCloneList] = useState([])

  // 与 SpyX 一致：Features 展示完整主列表和其他菜单功能，不限移动端数量。
  useEffect(() => {
    setCloneList([...typeModule, ...otherModule])
  }, [typeModule, otherModule])

  // 数据量最多的常用app列表
  const [frequentlyArr, setFrequentlyArr] = useState([])

  // 常用功能列表仍保留原有排序逻辑。
  useEffect(() => {
    if (window.innerWidth < 780 && typeModule && typeModule.length > 0) {
      // 过滤出指定 name 的 icon 并按 num 值降序排序
      let selectedIcons = typeModule.filter(icon => {
        return (
          [
            'Text message',
            'WhatsApp',
            'Messenger',
            'Locations',
            'Photo',
            'Video',
            'Call',
            'Browser Bookmark',
            'Snapchat'
          ].includes(icon.name) && icon.num > 0
        )
      })

      if (selectedIcons.length === 0) {
        return
      }

      // 过滤出不在 selectedIcons 中的其他 icon 并按 num 值降序排序
      let _selectedIcons = typeModule
        .filter(
          icon =>
            !(
              [
                'Text message',
                'WhatsApp',
                'Messenger',
                'Locations',
                'Photo',
                'Video',
                'Call',
                'Browser Bookmark',
                'Snapchat'
              ].includes(icon.name) && icon.num > 0
            )
        )
        .sort((a, b) => b.num - a.num)
      localStorage.setItem(
        'frequentlyArr',
        JSON.stringify([...selectedIcons, ..._selectedIcons].sort((a, b) => b.num - a.num).slice(0, 3))
      )

      setFrequentlyArr([...selectedIcons, ..._selectedIcons].sort((a, b) => b.num - a.num).slice(0, 3))
    } else {
      localStorage.setItem('frequentlyArr', JSON.stringify([...typeModule].sort((a, b) => b.num - a.num).slice(0, 3)))

      setFrequentlyArr([...typeModule].sort((a, b) => b.num - a.num).slice(0, 3))
    }
  }, [typeModule])

  // getData
  const getData = async requestKey => {
    setIsLoading(true)
    try {
      let contact = await getLocalAndroidAll({
        username: userData.email,
        params: {
          category: 'CONTACT',
          deviceUdid: readDeviceUsername(),
          offset: 0,
          limit: 5
        }
      })

      if (deviceRequestKeyRef.current !== requestKey) return

      if (contact.code === 1002 || contact.data.ec === 40002) {
        setIsLoading(false)

        return
      }
      let all = await getLocalAndroidAll({
        username: userData.email,
        params: {
          category: 'USER_SUMMARY',
          deviceUdid: readDeviceUsername(),
          offset: 0,
          limit: 5
        }
      })

      if (deviceRequestKeyRef.current !== requestKey) return

      let currentDevice = JSON.parse(localStorage.getItem('currentDevice')) || { id: 0 }
      const summary = all?.data?.summary || {}

      let currentAllData

      if (summary.advance != null) {
        currentAllData = summary.advance.find(row => row.device.id == currentDevice.id)

        const _arr = [
          'screenshot_facebook',
          'screenshot_facebook_messenger',
          'screenshot_instagram',
          'screenshot_kik',
          'screenshot_line',
          'screenshot_qq',
          'screenshot_skype',
          'screenshot_snapchat',
          'screenshot_teams',
          'screenshot_telegram',
          'screenshot_tiktok',
          'screenshot_tinder',
          'screenshot_viber',
          'screenshot_wechat',
          'screenshot_whatsapp',
          'screenshot_youtube'
        ]

        let _isHasData = false
        for (const key in _arr) {
          if (currentAllData instanceof Array && currentAllData[key]) {
            _isHasData = true
          }
        }
        setIsInviteComment(_isHasData)
      }

      // USER_SUMMARY 的 geofencing 数量在设备 advance 行上（后端按当前设备填充），不在 summary 顶层。
      const currentAdvanceData = currentAllData || summary.advance?.find(row => row.device?.id == currentDevice.id)
      const featureList = typeModule.map(item => applyAdvanceBadgeCount(item, currentAdvanceData))
      setTypeModule(featureList)
      setOtherModule(otherAppList.map(item => applyAdvanceBadgeCount(item, currentAdvanceData)))

      localStorage.setItem('userSummary', JSON.stringify(featureList))

      // currentAllData.filter(item => item)
    } finally {
      if (deviceRequestKeyRef.current === requestKey) {
        setIsLoading(false)
      }
    }
  }

  useEffect(() => {
    setTypeModule(allIcon.map(item => ({ ...item })))
    getData(deviceRequestKey)
  }, [deviceRequestKey])

  const [orderData, setOrderData] = useState([])
  const [orderListData, setOrderListData] = useState({})

  // 当前设备的平台类型。必须以【设备接口】user-device 为准：
  // 订单接口 user-account-order 的 platform_type 是「购买的产品」，
  // 不等于当前设备类型（安卓设备的订单也可能是 iOS 产品）。
  const [currentDevicePlatform, setCurrentDevicePlatform] = useState('')
  const [orderIndex, setOrderIndex] = useState(0)
  const [showOrderList, setShowOrderList] = useState(false)
  const [targetDeviceList, setTargetDeviceList] = useState([])

  const orderListRef = useRef(null)
  const toggleButtonRef = useRef(null) // 绑定按钮引用

  // 点击按钮显示/隐藏弹窗
  const handleClickOutside = event => {
    // 检查点击的地方是否在按钮或弹窗内
    if (
      showOrderList &&
      orderListRef.current &&
      !orderListRef.current.contains(event.target) &&
      toggleButtonRef.current &&
      !toggleButtonRef.current.contains(event.target)
    ) {
      setShowOrderList(false)
    }
  }

  const changeOrder = (item, index) => {
    setOrderListData(item)
    setOrderIndex(index)
    setShowOrderList(false)
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showOrderList]) // 依赖于 showOrderList

  const FirstOrderData = async requestKey => {
    // 设备接口失败不应连累订单卡片，故单独兜底为 null
    const [allDeviceUser, deviceRes] = await Promise.all([
      getUserAccountOrder({ page: 1, pageSize: 9999 }),
      getAllUserDevice({}).catch(() => null)
    ])

    if (deviceRequestKeyRef.current !== requestKey) return

    // 当前设备类型取【设备接口】user-device，不能用订单接口的 platform_type。
    let storedDeviceUser = {}
    try {
      storedDeviceUser = JSON.parse(localStorage.getItem('DeviceUser') || '{}') || {}
    } catch {
      storedDeviceUser = {}
    }
    const matchedDevice = matchCurrentDevice(deviceRes?.data, storedDeviceUser)
    setCurrentDevicePlatform(matchedDevice?.platform_type || '')

    let all = allDeviceUser.data

    // 遍历数组并设置 `name` 属性
    all?.forEach((item, index) => {
      item.name = `Acount${String(index + 1).padStart(2, '0')}`
    })
    setOrderData(all || [])
    if (all.length > 0) {
      let DeviceUser = null
      try {
        DeviceUser = JSON.parse(localStorage.getItem('DeviceUser') || 'null')
      } catch (e) {
        DeviceUser = null
      }

      // 当前设备的关联订单：优先用设备接口的 order_id 直接命中订单主键；
      // 没有 order_id 时按 device_id 找，命中多张则取过期时间最晚的那张（最新的关联单）。
      let lastOrder = DeviceUser
        ? resolveDeviceOrder({ orders: all, deviceUser: DeviceUser, device: matchedDevice })
        : null

      // 没有设备上下文（未选中任何设备）时才退回「全局过期最晚的一张」
      if (!lastOrder && !DeviceUser) {
        lastOrder = pickLatestExpireOrder(all)
      }

      // 卡片展示以【设备接口】为准：user-device 现在直接返回
      // order_id / product_name / order_level / expire_time，就是这台设备当前的订阅状态；
      // 订单只用于补设备接口没有的字段（如 merchant_no → 注册码行）。
      setOrderListData(resolveCardSubscription({ order: lastOrder, device: matchedDevice }))
    }
  }

  // 获取设备信息
  const getDeviceList = async requestKey => {
    const get = await getLocalAndroidAll({
      username: userData.email,
      params: {
        category: 'DEVICE_LIST',
        offset: 0,
        limit: 100,
      }
    })
    if (deviceRequestKeyRef.current !== requestKey) return
    if (get.data.contents) setTargetDeviceList(get.data.contents)
  }

  useEffect(() => {
    FirstOrderData(deviceRequestKey)
    getDeviceList(deviceRequestKey)
  }, [deviceRequestKey])

  // 延长续订
  const [extendSubscriptionModal, setExtendSubscriptionModal] = useState(false)

  const extendSubscription = async () => {
    const renewId = await fetchRenewProductIdForOrder(orderListData)
    if (!renewId) {
      window.dispatchEvent(new Event('renewalFailed'))
      messageInfo({
        content: t('Payment failed'),
        duration: 6
      })
      setExtendSubscriptionModal(false)

      return
    }

    let result = await extendSubscriptionTime({
      merchant_no: orderListData.merchant_no,
      renewId,
      order_type: 274
    })
    if (Number(result.code) === 0) {
      messageInfo({
        content: `${result.msg}`,
        duration: 1.5
      })
      setExtendSubscriptionModal(false)

      // 与 iOS dashboard / ExpiredPurchaseGuide 一致：整页刷新，避免过期 banner/遮罩残留
      reloadAfterRenewSuccess()

      return
    }

    window.dispatchEvent(new Event('renewalFailed'))

    messageInfo({
      content: `${result.msg}`,
      duration: 6
    })

    setExtendSubscriptionModal(false)
  }

  const openNav = () => {
    dispatch(toggleNavVisibility(true))
  }

  useEffect(() => {
    dispatch(setCurrentTab(t('Dashboard')))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  // 埋点上报
  useEffect(() => {
  }, [])

  const [favoriteArr, setFavoriteArr] = useState([])
  const menuCacheRef = useRef({}) // { [device_id]: menuList }

  // 初始化收藏菜单功能数组
  useEffect(() => {
    const requestKey = deviceRequestKey
    const init = async (forceRefresh = false) => {
      if (!typeModule?.length) return
      const deviceUser = localStorage.getItem('DeviceUser')
      const device_id = deviceUser ? JSON.parse(deviceUser).device_id : ''
      if (!device_id) return

      // 用完整列表映射，避免 cloneList 在移动端被 slice(0,9) 后丢收藏项
      const typeModuleMap = new Map(typeModule.map(item => [(item.href || item.url).toLowerCase(), item]))
      const otherAppListMap = new Map(otherAppList.map(item => [(item.href || item.url).toLowerCase(), item]))

      // 使用缓存，除非 forceRefresh 为 true
      let menuList = menuCacheRef.current[device_id]
      if (!menuList || forceRefresh) {
        menuList = await getMenuFavorite(device_id)
        if (deviceRequestKeyRef.current !== requestKey) return
        menuCacheRef.current[device_id] = menuList
      }

      // 初始化默认菜单
      const hasInit = localStorage.getItem(`menuFavoriteInit-${device_id}`)
      if (!hasInit && (!menuList?.data || menuList.data.length === 0)) {
        localStorage.setItem(`menuFavoriteInit-${device_id}`, 'true')

        await Promise.all([
          postMenuFavorite({
            device_id: device_id,
            name: 'Text message',
            url: '/android/local/text-messages',
            status: true
          }),
          postMenuFavorite({ device_id: device_id, name: 'WhatsApp', url: '/android/local/whatsapp', status: true }),
          postMenuFavorite({ device_id: device_id, name: 'Facebook', url: '/android/local/facebook', status: true }),
          postMenuFavorite({ device_id: device_id, name: 'Instagram', url: '/android/local/instagram', status: true })
        ])
        if (deviceRequestKeyRef.current !== requestKey) return

        // 再次拉取数据，重试保证接口有数据
        let retry = 3
        while (retry > 0) {
          menuList = await getMenuFavorite(device_id)
          if (deviceRequestKeyRef.current !== requestKey) return
          if (menuList?.data && menuList.data.length > 0) break
          await new Promise(resolve => setTimeout(resolve, 100))
          retry--
        }
        menuCacheRef.current[device_id] = menuList
      }

      // 构造 favoriteArr
      const result = (menuList?.data || [])
        .map(item => typeModuleMap.get(item.url.toLowerCase()) || otherAppListMap.get(item.url.toLowerCase()))
        .filter(Boolean)

      if (deviceRequestKeyRef.current !== requestKey) return
      setFavoriteArr(result)
    }

    init()
    const handler = () => init(true) // 强制刷新
    window.addEventListener('menuUpdated', handler)

    return () => {
      window.removeEventListener('menuUpdated', handler)
    }
  }, [typeModule, deviceRequestKey])

  // 卡片上判断「是不是 iOS / 安卓」一律用设备类型（设备接口），
  // 订单类型只作为设备类型取不到时的兜底，避免改变原有表现。
  const cardPlatformType = currentDevicePlatform || orderListData?.platform_type || ''
  const selectedTargetDeviceId = readDeviceUsername()
  let selectedTargetDevice = targetDeviceList.find(
    item => String(item?.id || '') === String(selectedTargetDeviceId)
  )
  if (!selectedTargetDevice) {
    try {
      const currentDevice = JSON.parse(localStorage.getItem('currentDevice') || 'null')
      if (String(currentDevice?.id || '') === String(selectedTargetDeviceId)) {
        selectedTargetDevice = currentDevice
      }
    } catch {
      selectedTargetDevice = null
    }
  }

  return (
    <div style={{ userSelect: 'none' }}>
      {/* <FirstBinding /> */}
      <ExpirationReminder orders={orderData} />
      <DisconnectDetection />
      <PermissionCheck key={deviceRequestKey || 'none'} />
      <div className='relative min-h-[calc(var(--vh2)*100-90px)]'>
        {isLoading ? (
          <div className='absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]'>
            <ContentLoading />
          </div>
        ) : null}
      <Grid container spacing={6}>
        <Grid item xs={12} md={12} lg={12}>
          {/* <Card style={{ width: '100%', marginBottom: '20px' }} sx={{
            '@media (min-width: 1200px)': {
              display: 'none'
            }
          }}>
            <div className='w-full flex justify-between items-center mb-[10px] px-[18px] pt-4'>
              <h2 className='text-[18px] text-[#222] font-[600] Bxls:hidden'>{t('Frequently used')}</h2>
            </div>
            <CardContent style={{ display: 'flex', flexWrap: 'wrap', paddingBottom: '0px' }}>
              {frequentlyArr.map(row => (
                <Grid
                  key={row.id}
                  item
                  xs={4}
                  md={3}
                  lg={2}
                  className='sm:hidden'
                  style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '10px'
                  }}
                >
                  <Link
                    className='flex flex-col items-center justify-center'
                    href={row.href}
                  >
                    <div className='w-[50px] h-[50px] relative'>
                      <Image
                        src={row.img}
                        alt='img'
                        width={50}
                        height={50}
                        className='mx-auto p-2 rounded-[14px] bg-[#F0F1F5] relative'
                      />
                      <span className='absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center'>
                        {row.num}
                      </span>
                    </div>

                    <span
                      className='text-[12px] Blds:text-[14px] text-[#2E2E2E] mt-[6px] h-[48px] w-full text-center'
                      style={{ textAlign: 'center' }}
                    >
                      {t(row.name)}
                    </span>
                  </Link>
                </Grid>
              ))}
            </CardContent>
          </Card> */}

          <Card style={{ width: '100%', marginBottom: '20px' }} className={`${favoriteArr.length === 0 && 'hidden'}`}>
            <div className='w-full flex justify-between items-center mb-[10px] px-[18px] pt-4'>
              <h2 className='text-[18px] text-[#222] font-[600]'>{t('Favorites')}</h2>
            </div>
            <CardContent style={{ display: 'flex', flexWrap: 'wrap' }}>
              {favoriteArr.map(row => (
                <Grid
                  key={row.id}
                  item
                  xs={4}
                  md={3}
                  lg={2}
                  style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '10px'
                  }}
                >
                  <Link
                    className='flex flex-col items-center justify-center'
                    href={row.href}
                    onClick={() => {
                    }}
                  >
                    <div className='w-[50px] h-[50px] relative'>
                      <Image
                        src={row.img}
                        alt='img'
                        width={50}
                        height={50}
                        className={`mx-auto relative rounded-[14px] ${row.noBg ? '' : 'p-2 bg-[#F0F1F5]'}`}
                      />
                      <span className='absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center'>
                        {row.num}
                      </span>
                    </div>

                    <span
                      className='text-[12px] Blds:text-[14px] text-[#2E2E2E] mt-[6px] h-[48px] w-full text-center'
                      style={{ textAlign: 'center' }}
                    >
                      {t(row.name)}
                    </span>
                  </Link>
                </Grid>
              ))}
            </CardContent>
          </Card>

          <Card style={{ width: '100%' }}>
            <div className='w-full flex justify-between items-center mb-[10px] px-[18px] pt-4'>
              <h2 className='text-[18px] text-[#222] font-[600] Bxls:hidden'>{t('Hot features')}</h2>
              <h2 className='text-[18px] text-[#222] font-[600] hidden Bxls:block'>{t('Features')}</h2>
              <div
                className=' border-0 px-[10px] h-[30px] rounded-[22.5px] hover:bg-[#454CFF] text-[#454CFF] hover:text-[#FFF] text-[12px] Bxls:hidden flex items-center font-[600]'
                onClick={openNav}
              >
                {t('SEE ALL')}
              </div>
            </div>
            <CardContent style={{ display: 'flex', flexWrap: 'wrap' }}>
              {cloneList.map(row => (
                <Grid
                  key={row.id}
                  item
                  xs={4}
                  md={3}
                  lg={2}
                  style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '10px'
                  }}
                >
                  <Link
                    className='flex flex-col items-center justify-center'
                    href={row.href}
                    onClick={() => {
                    }}
                  >
                    <div className='w-[50px] h-[50px] relative'>
                      <Image
                        src={row.img}
                        alt='img'
                        width={50}
                        height={50}
                        className={`mx-auto relative rounded-[14px] ${row.noBg ? '' : 'p-2 bg-[#F0F1F5]'}`}
                      />
                      <span className='absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center'>
                        {row.num}
                      </span>
                    </div>

                    <span
                      className='text-[12px] Blds:text-[14px] text-[#2E2E2E] mt-[6px] h-[48px] w-full text-center'
                      style={{ textAlign: 'center' }}
                    >
                      {t(row.name)}
                    </span>
                  </Link>
                </Grid>
              ))}
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <div className='grid grid-cols-3 Hsm:grid-cols-2 Hsm:Dsm:grid-cols-1 w-full gap-[20px] mt-[20px]'>
        <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[18px] px-[18px] pb-[30px]'>
          <div className='flex justify-between items-center relative'>
            <h2 className='text-[18px] text-[#222] font-[600]'>{t('Account')}</h2>
            {/* <div
              className='hover:cursor-pointer'
              ref={toggleButtonRef} // 绑定按钮引用
              onClick={event => {
                event.stopPropagation() // 阻止事件冒泡
                setShowOrderList(prev => !prev) // 确保状态切换
              }}
            >
              <Image
                className='w-[24px] h-[24px]'
                src='/images/change-password/drop-down.svg'
                width={24}
                height={24}
                alt='drop down'
              ></Image>
            </div> */}
            {showOrderList && (
              <div
                ref={orderListRef}
                className='bg-[#FFF] w-full absolute left-0 top-[40px] z-10 rounded-[8px] p-[8px] drop-shadow-[0_4px_8px_rgba(0,0,0,0.13)] overflow-auto'
              >
                {orderData.map((row, index) => (
                  <div
                    key={index}
                    onClick={() => changeOrder(row, index)}
                    className={`hover:bg-[#F4F5F6] hover:cursor-pointer px-[15px] py-[10px] ${
                      orderIndex === index ? 'bg-[#F4F5F6]' : ''
                    }`}
                  >
                    {row.name}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className='w-full h-[1px] bg-[#E5E5E5] my-[20px]'></div>
          <div className='w-full h-auto flex flex-col justify-between text-[14px]'>
            <div className='w-full flex justify-between items-center h-[36px]'>
              <div className='text-[#334062]'>{t('Product')}:</div>
              <div className='text-[#9198AD]'>{cardPlatformType}</div>
            </div>
            <div className='w-full flex justify-between items-center h-[36px]'>
              <div className='text-[#334062]'>{t('Subscription Plan')}:</div>
              <div className='text-[#9198AD]'>
                {cardPlatformType === 'iOS-Cloud' &&
                  (isBasicOrderLevel(orderListData?.order_level) ? `${t('Basic')} - ` : 'Extreme - ')}
                {orderListData?.product_name}
              </div>
            </div>
            <div className='w-full flex justify-between items-center h-[36px]'>
              <div className='text-[#334062]'>{t('Expiry Date')}:</div>
              <div className='text-[#9198AD]'>{dayjs(orderListData.expire_time).format('YYYY-MM-DD')}</div>
            </div>
            <div
              className={`w-full flex justify-between items-center h-[36px] ${
                cardPlatformType.includes('Android') && new Date(orderListData?.expire_time) > new Date()
                  ? 'block'
                  : 'hidden'
              }`}
            >
              <div className='text-[#334062]'>{t('Registration Code')}:</div>
              <div className='text-[#9198AD]'>{orderListData?.merchant_no?.slice(-8)}</div>
            </div>
          </div>
          <button
            className='text-[#454CFF] w-full h-[45px] border border-[#454CFF] rounded-[22.5px] mt-[36px] hover:bg-[#454CFF] hover:text-[#FFF]'
            onClick={() => setExtendSubscriptionModal(true)}
          >
            {t('Extend subscription')}
          </button>
        </div>

        <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[18px] px-[18px] pb-[24px] w-full aspect-square self-start overflow-hidden flex flex-col'>
          <h2 className='text-[18px] text-[#222] font-[600] mb-[20px]'>{t('Target Device Info')}</h2>
          <div className='w-full h-[54px] bg-[#F4F5F6] rounded-[8px] pl-[8px] pr-[14px] relative flex items-center text-[#334062] text-[16px]'>
            <div className='ml-[10px]'>
              {selectedTargetDevice?.name || ''}
            </div>
          </div>
          <div className='w-full h-[108px] mt-[24px] flex flex-col justify-between'>
            <div className='w-full flex justify-between items-center text-[14px]'>
              <div className='text-[#334062]'>IMEI:</div>
              <div className='text-[#9198AD]'>{selectedTargetDevice?.serial_number}</div>
            </div>
            <div className='w-full flex justify-between items-center text-[14px]'>
              <div className='text-[#334062]'>Version:</div>
              <div className='text-[#9198AD]'>{selectedTargetDevice?.version}</div>
            </div>
            <div className='w-full flex justify-between items-center text-[14px]'>
              <div className='text-[#334062]'>Model:</div>
              <div className='text-[#9198AD]'>{selectedTargetDevice?.model}</div>
            </div>
            {/* <div className='w-full flex justify-between items-center text-[14px]'>
              <div className='text-[#334062]'>Last backup size:</div>
              <div className='text-[#9198AD]'>{targetDeviceList[currentIndex]?.size}</div>
            </div> */}
          </div>
        </div>
      </div>
      </div>

      {/* 延长续费 */}

      <Modal open={extendSubscriptionModal} onCancel={() => setExtendSubscriptionModal(false)} footer={[]}>
        <p style={{ marginTop: '10px', fontWeight: '600' }}>
          {t('After confirmation a new order will be produced to extend the equipment expiration time')}
        </p>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '14px' }}>
          <Button onClick={() => extendSubscription()} style={{ marginRight: '10px' }}>
            {t('Confirm')}
          </Button>
          <Button onClick={() => setExtendSubscriptionModal(false)}>{t('Cancel')}</Button>
        </div>
      </Modal>

      {contextHolder}
    </div>
  )
}

export default Dashboard


